import { inject, Injectable } from "@angular/core";
import { ofType } from "@ngrx/effects";
import { EffectsBase } from "clicklease-ui-elements";
import * as paymentActions from './payment-link.actions';
import { PersonalInformationIdSelector } from "../personal-information/personal-information.selectors";
import { RoseService } from "../../services";
import { catchError, first, map, mergeMap, of } from "rxjs";
import { PaymentLink } from "../../interfaces";
import { getContractSelectedSelector } from "../contracts/contracts.selectors";

@Injectable()
export class PaymentLinkEffect extends EffectsBase {
    readonly #roseId = this.store.selectSignal(PersonalInformationIdSelector);
    readonly #contract = this.store.selectSignal(getContractSelectedSelector);

    readonly #roseService: RoseService = inject(RoseService);

    fetchPaymentLinkEffect = this.createEffect(() =>
        this.actions.pipe(
            ofType(paymentActions.fetchPaymentLinkAction),
            mergeMap(() => this.#roseService.getPaymentLink(this.#roseId(), this.#contract()?.id || '').pipe(
                map((data: PaymentLink) => paymentActions.fetchPaymentLinkSuccessAction(data)),
                catchError(() => of(paymentActions.fetchPaymentLinkErrorAction())),
                first()
            ))
        )
    );
}